export default __webpack_public_path__ + "096bdcab7343e1ccf290ee49bb8f0d9c.svg";